export default __webpack_public_path__ + "static/media/12.900e8d00.jpg";